var _path, _path2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInvoicewedadmin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2074_20594",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H16V16H0V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2074_20594)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_2074_20594",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H16V16H0V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_2074_20594)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.62187 6.5375C7.53125 6.5375 7.52812 7.50313 7.68437 8.00313C7.85938 7.69063 7.88437 6.5375 7.62187 6.5375ZM7.63125 9.47813C7.39062 10.1094 7.09062 10.8313 6.74375 11.4375C7.31563 11.2188 7.9625 10.9 8.70938 10.7531C8.3125 10.4531 7.93125 10.0219 7.63125 9.47813ZM5.78125 12.1219C5.10312 13.2094 4.69062 13.4031 4.69062 13.3781C4.87188 12.8875 5.57188 12.3187 5.78125 12.1219ZM9.75 5H14V15.25C14 15.6656 13.6656 16 13.25 16H2.75C2.33437 16 2 15.6656 2 15.25V0.75C2 0.334375 2.33437 0 2.75 0H9V4.25C9 4.6625 9.3375 5 9.75 5ZM9.5 10.3687C8.875 9.9875 8.45937 9.4625 8.16563 8.6875C8.30625 8.10938 8.52813 7.23125 8.35938 6.68125C8.2125 5.7625 7.03438 5.85313 6.86562 6.46875C6.70937 7.04063 6.85313 7.84688 7.11875 8.875C6.75625 9.7375 6.22188 10.8938 5.84375 11.5562C5.84063 11.5562 5.84063 11.5594 5.8375 11.5594C4.99063 11.9937 3.5375 12.95 4.13438 13.6844C4.30938 13.9 4.63438 13.9969 4.80625 13.9969C5.36563 13.9969 5.92188 13.4344 6.71562 12.0656C7.52187 11.8 8.40625 11.4688 9.18437 11.3406C9.8625 11.7094 10.6562 11.95 11.1844 11.95C12.0969 11.95 12.1594 10.95 11.8 10.5938C11.3656 10.1687 10.1031 10.2906 9.5 10.3687ZM13.7812 3.28125L10.7188 0.21875C10.5781 0.078125 10.3875 0 10.1875 0H10V4H14V3.80938C14 3.6125 13.9219 3.42188 13.7812 3.28125ZM10.1281 10.9781C11.3875 10.8875 11.5938 11.175 11.4656 11.2594C11.4656 11.2594 11.2875 11.4719 10.1281 10.9781Z",
    fill: "#EF4444"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvoicewedadmin);
export default __webpack_public_path__ + "static/media/invoicewedadmin.ea68812ef937005138328c8c888f131f.svg";
export { ForwardRef as ReactComponent };